var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.billing.message.billingalerts") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "Col",
                    {
                      staticClass: "col-md-12 no-padding",
                      staticStyle: { height: "24px" }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "apps.billing.message.autobillingmonthlyinvoice"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group col-12",
                      staticStyle: {
                        padding: "0px",
                        margin: "0px",
                        height: "35px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "box-input" },
                        [
                          _c(
                            "vs-checkbox",
                            {
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "1px",
                                left: "-5px"
                              },
                              attrs: { color: "#A3CA76" },
                              model: {
                                value: _vm.is_enabled_monthly_invoice_charge,
                                callback: function($$v) {
                                  _vm.is_enabled_monthly_invoice_charge = $$v
                                },
                                expression: "is_enabled_monthly_invoice_charge"
                              }
                            },
                            [
                              _vm.is_enabled_monthly_invoice_charge
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.yes")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.no")))
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "Col",
                    {
                      staticClass: "col-md-12 no-padding",
                      staticStyle: { height: "24px" }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("apps.billing.message.receiveemailalerts")
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group col-12",
                      staticStyle: {
                        padding: "0px",
                        margin: "0px",
                        height: "35px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "box-input" },
                        [
                          _c(
                            "vs-checkbox",
                            {
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "1px",
                                left: "-5px"
                              },
                              attrs: { color: "#A3CA76" },
                              model: {
                                value: _vm.is_enabled_receive_invoice_email,
                                callback: function($$v) {
                                  _vm.is_enabled_receive_invoice_email = $$v
                                },
                                expression: "is_enabled_receive_invoice_email"
                              }
                            },
                            [
                              _vm.is_enabled_receive_invoice_email
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.yes")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.no")))
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "Col",
                    {
                      staticClass: "col-md-12 no-padding",
                      staticStyle: { height: "24px" }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "apps.billing.message.receivemessagenotification"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group col-12",
                      staticStyle: {
                        padding: "0px",
                        margin: "0px",
                        height: "35px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "box-input" },
                        [
                          _c(
                            "vs-checkbox",
                            {
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "1px",
                                left: "-5px"
                              },
                              attrs: { color: "#A3CA76" },
                              model: {
                                value:
                                  _vm.is_enabled_receive_invoice_notification_desktop,
                                callback: function($$v) {
                                  _vm.is_enabled_receive_invoice_notification_desktop = $$v
                                },
                                expression:
                                  "is_enabled_receive_invoice_notification_desktop"
                              }
                            },
                            [
                              _vm.is_enabled_receive_invoice_notification_desktop
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.yes")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.no")))
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseFormAction", {
        attrs: {
          textSubmit: _vm.$t("button.save"),
          isSubmitted: false,
          isHideCloseButton: true
        },
        on: { onSubmit: _vm.handleSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3651c5b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3651c5b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseFormBillingPreference.vue
// module id = null
// module chunks = 